// ======================================================================
// File Name       : ContentDistributionAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import { decamelizeKeys, camelizeKeys } from 'humps';
import $ from 'jquery';
import _ from 'lodash';
import moment from 'moment';
import * as actionTypes from '../constants/ActionTypes';
import { commonCallApi } from '../utils/ApiUtils';
import * as contentDistributionActionTypes from '../constants/actionTypes/contentDistribution';
import { SUPERUSER_SORT_TYPE } from '../constants/SuperUserContants';
import * as distributionConstant from '../constants/ContentDistributionConstant';
import { SELECT_TARGET_DATA, RETURN_MAX_NUM, DEFAULT_DATE_SHORT_FORMAT_SERVER, MODE } from '../constants/index';
import { CONTENT_DISTRIBUTION } from '../constants/PathConstants';
import {
  sendImportDistributionRequest,
  sendGetDistributionListFileRequest,
  getCourseStatus,
  doContentPermissionSyncCourses,
  doContentPermissionSendSyncContents,
} from './httpRequests/contentDistribution';
import { MAX_DATE, MIN_DATE, parseDateForDetail, downloadFile } from '../utils/index';
import { DISTRIBUTION_OFFER_TYPE } from '../constants/ContentConstant';
import * as actionCreators from './actionCreators/contentDistribution';

export function distributionServiceSearch(searchInfo, auth) {
  return dispatch => commonCallApi({
    path: 'contentsPermission/GetServiceList',
    data: searchInfo,
  })
    .then((camelizeJson) => {
      dispatch({
        type: actionTypes.CONTENT_DISTRIBUTION_SERVICE_SEARCH,
        distributionServiceListInfo: camelizeJson,
      });
    });
}

export function getEnterpriseList(auth) {
  return (dispatch) => {
    const param = {
      authCd: auth.authCd,
      enterpriseId: auth.enterpriseId,
      selectTargetData: SELECT_TARGET_DATA.DATA,
    };
    const decamelParam = decamelizeKeys(param);
    commonCallApi({
      path: 'enterprise/GetStructure',
      data: decamelParam,
    })
      .then((camelizeJson) => {
        dispatch({
          type: actionTypes.CONTENT_DISTRIBUTION_SERVICE_RECEIVE_ENRTERPRISES,
          enterpriseList: camelizeJson.enterpriseList,
        });
      });
  };
}

export function getContentDistributionServiceName(serviceId) {
  return (dispatch) => {
    const deCamelSearchInfo = decamelizeKeys(serviceId);
    commonCallApi({
      path: 'contentsPermission/SearchService',
      data: deCamelSearchInfo,
    })
    .then((camelizeJson) => {
      dispatch(actionCreators.receiveContentDistributionServiceName(camelizeJson));
    });
  };
}

export function addItemToDistributionList(addedItems, offerType) {
  return (dispatch) => {
    const itemList = $.extend(true, [], addedItems);
    const itemListLength = itemList ? itemList.length : 0;
    for (let i = 0; i < itemListLength; i++) {
      if (itemList[i].isChecked) {
        itemList[i].distributionStartDate = moment();
        itemList[i].distributionEndDate = MAX_DATE;
        itemList[i].addedNew = true;
        itemList[i].isChecked = false;
      }
    }
    const recordNum = itemList ? itemList.length : 0;
    if (offerType === DISTRIBUTION_OFFER_TYPE.CONTENT) {
      dispatch(actionCreators.updateContentDistributionList(itemList, recordNum));
    } else if (offerType === DISTRIBUTION_OFFER_TYPE.COURSE) {
      dispatch(actionCreators.updateCourseDistributionList(itemList, recordNum));
    }
  };
}

export function deleteContentFromDistributionList(contentList, id, contentType) {
  return (dispatch) => {
    const listLength = contentList ? contentList.length : 0;
    let deleteIndex = -1;
    for (let i = 0; i < listLength; i++) {
      if (contentList[i].contentSecernId === id && contentList[i].contentType === contentType) {
        deleteIndex = i;
        break;
      }
    }
    if (deleteIndex !== -1) {
      contentList.splice(deleteIndex, 1);
    }
    const recordNum = contentList ? contentList.length : 0;
    dispatch(actionCreators.updateContentDistributionList(contentList, recordNum));
  };
}

export function deleteCourseFromDistributionList(courseList, id) {
  return (dispatch) => {
    const listLength = courseList ? courseList.length : 0;
    let deleteIndex = -1;
    for (let i = 0; i < listLength; i++) {
      if (courseList[i].courseSecernId === id) {
        deleteIndex = i;
        break;
      }
    }
    if (deleteIndex !== -1) {
      courseList.splice(deleteIndex, 1);
    }
    const recordNum = courseList ? courseList.length : 0;
    dispatch(actionCreators.updateCourseDistributionList(courseList, recordNum));
  };
}

export function changeDateTimeOfContent(value, id, name, contentList, contentType) {
  return (dispatch) => {
    const listLength = contentList ? contentList.length : 0;
    for (let i = 0; i < listLength; i++) {
      if (contentList[i].contentSecernId === id && contentList[i].contentType === contentType) {
        if (!value) {
          value = MAX_DATE;
          if (name === 'distributionStartDate') {
            value = MIN_DATE;
          }
        }
        const newData = { ...contentList[i], ...{ [name]: value } };
        contentList[i] = newData;
        break;
      }
    }
    dispatch(actionCreators.updateContentDistributionList(contentList));
  };
}

export function changeDateTimeOfCourse(value, id, name, courseList) {
  return (dispatch) => {
    const listLength = courseList ? courseList.length : 0;
    for (let i = 0; i < listLength; i++) {
      if (courseList[i].courseSecernId === id) {
        if (!value) {
          value = MAX_DATE;
          if (name === 'distributionStartDate') {
            value = MIN_DATE;
          }
        }
        const newData = { ...courseList[i], ...{ [name]: value } };
        courseList[i] = newData;
        break;
      }
    }
    dispatch(actionCreators.updateCourseDistributionList(courseList));
  };
}

export function registerContentDistribution(paramsRegisService) {
  return (dispatch) => {
    const deCamelSearchInfo = decamelizeKeys(paramsRegisService);
    return commonCallApi({
      path: 'contentsPermission/EditService',
      data: deCamelSearchInfo,
    });
  };
}

export function registerContentDistributionWithSCD(params) {
  return (dispatch) => {
    const deCamelSearchInfo = decamelizeKeys(params);
    commonCallApi({
      path: 'contentsPermission/EditContents',
      data: deCamelSearchInfo,
    })
    .then((camelizeJson) => {
      dispatch(actionCreators.recieveSaveDistributionSuccess(camelizeJson));
    });
  };
}

export function editDistributionList(
  serviceCd,
  addedContentList,
  updatedContentList,
  deletedContentList,
  addedCourseList,
  updatedCourseList,
  deletedCourseList,
) {
  return async (dispatch) => {
    if (updatedContentList && updatedContentList.length) {
      await editDistributionCotent(MODE.EDIT_MODE, serviceCd, updatedContentList);
    }
    if (deletedContentList && deletedContentList.length) {
      await editDistributionCotent(MODE.DELETE_MODE, serviceCd, deletedContentList);
    }
    if (addedContentList && addedContentList.length) {
      await editDistributionCotent(MODE.NEW_MODE, serviceCd, addedContentList);
    }
    if (updatedCourseList && updatedCourseList.length) {
      await editDistributionCourse(MODE.EDIT_MODE, serviceCd, updatedCourseList);
    }
    if (deletedCourseList && deletedCourseList.length) {
      await editDistributionCourse(MODE.DELETE_MODE, serviceCd, deletedCourseList);
    }
    if (addedCourseList && addedCourseList.length) {
      await editDistributionCourse(MODE.NEW_MODE, serviceCd, addedCourseList);
    }
    return dispatch(actionCreators.recieveSaveDistributionSuccess({}));
  };
}

function editDistributionCotent(type, serviceCd, contentList) {
  const param = {
    editType: type,
    distributionServiceInfo: {
      serviceCd,
      distributionContentList: contentList,
    },
  };

  return commonCallApi({
    path: 'contentsPermission/EditContents',
    data: param,
  });
}

function editDistributionCourse(type, serviceCd, courseList) {
  const param = {
    editType: type,
    distributionServiceInfo: {
      serviceCd,
      distributionCourseList: courseList,
    },
  };

  return commonCallApi({
    path: 'contentsPermission/EditCourse',
    data: param,
  });
}

export function localSort(sortBy, ascending) {
  return (dispatch, getState) => {
    const state = getState();
    const { distributionOfferList } = state.contentDistribution;
    if (!distributionOfferList.distributionContentList) return;
    const sortKey = Object.keys(distributionConstant.registerSortType).find(
      key => distributionConstant.registerSortType[key] === sortBy,
    );
    const distributionContentList = _.orderBy(
      distributionOfferList.distributionContentList,
      [sortKey],
      [ascending === 1 ? 'asc' : 'desc'],
    );
    dispatch(actionCreators.localSorted(distributionContentList));
  };
}

export function getContentsList(auth, selectTargetData, searchInfo, serviceCd) {
  return (dispatch) => {
    let distributionContentSortType = null;
    let ascendingDescendingSort = null;
    if (searchInfo && searchInfo.distributionContentSortType != null) {
      distributionContentSortType = searchInfo.distributionContentSortType;
    }
    if (searchInfo && searchInfo.ascendingDescendingSort != null) {
      ascendingDescendingSort = searchInfo.ascendingDescendingSort;
    }
    const param = {
      institutionId: auth.institutionId,
      authCd: auth.authCd,
      selectTargetData,
      serviceCd,
      searchInfo: {
        contentSecernId: searchInfo && searchInfo.contentSecernId ? searchInfo.contentSecernId : '',
        contentType: searchInfo && searchInfo.contentType ? searchInfo.contentType : '',
        contentName: searchInfo && searchInfo.contentName ? searchInfo.contentName : '',
        distributionStartDate: searchInfo && searchInfo.distributionStartDate ?
        parseDateForDetail(searchInfo.distributionStartDate, DEFAULT_DATE_SHORT_FORMAT_SERVER) :
        null,
        distributionEndDate: searchInfo && searchInfo.distributionEndDate ?
        parseDateForDetail(searchInfo.distributionEndDate, DEFAULT_DATE_SHORT_FORMAT_SERVER) :
        null,
        distributionContentSortType,
        ascendingDescendingSort,
        startPosition: searchInfo ? searchInfo.startPosition : 0,
        returnMaxNum: searchInfo && searchInfo.returnMaxNum ?
        searchInfo.returnMaxNum : RETURN_MAX_NUM,
      },
    };
    const decamelDataToSearch = decamelizeKeys(param);
    return commonCallApi({
      path: 'contentsPermission/GetContentsList',
      data: decamelDataToSearch,
    })
      .then((camelizeJson) => {
        if (selectTargetData === SELECT_TARGET_DATA.DATA) {
          dispatch(actionCreators.receiveOfferListSearchContentResult(camelizeJson));
        } else if (camelizeJson && camelizeJson.csvfileUrl) {
          downloadFile(camelizeJson.csvfileUrl);
        }
      });
  };
}

export function getCourseListForDetail(auth, selectTargetData, searchInfo, serviceCd) {
  return (dispatch) => {
    let distributionCourseSortType = null;
    let ascendingDescendingSort = null;
    if (searchInfo && searchInfo.distributionCourseSortType != null) {
      distributionCourseSortType = searchInfo.distributionCourseSortType;
    }
    if (searchInfo && searchInfo.ascendingDescendingSort != null) {
      ascendingDescendingSort = searchInfo.ascendingDescendingSort;
    }
    const param = {
      institutionId: auth.institutionId,
      authCd: auth.authCd,
      selectTargetData,
      serviceCd,
      searchInfo: {
        courseName: searchInfo ? searchInfo.courseName : '',
        distributionStartDate: searchInfo && searchInfo.distributionStartDate ?
        parseDateForDetail(searchInfo.distributionStartDate, DEFAULT_DATE_SHORT_FORMAT_SERVER) :
        null,
        distributionEndDate: searchInfo && searchInfo.distributionEndDate ?
        parseDateForDetail(searchInfo.distributionEndDate, DEFAULT_DATE_SHORT_FORMAT_SERVER) :
        null,
        distributionCourseSortType,
        ascendingDescendingSort,
        startPosition: searchInfo ? searchInfo.startPosition : 0,
        returnMaxNum: searchInfo && searchInfo.returnMaxNum ?
        searchInfo.returnMaxNum : RETURN_MAX_NUM,
      },
    };
    const decamelDataToSearch = decamelizeKeys(param);
    return commonCallApi({
      path: 'contentsPermission/GetCourseList',
      data: decamelDataToSearch,
    })
      .then((camelizeJson) => {
        if (selectTargetData === SELECT_TARGET_DATA.DATA) {
          dispatch(actionCreators.receiveOfferListSearchCourseResult(camelizeJson));
        } else if (camelizeJson && camelizeJson.csvfileUrl) {
          downloadFile(camelizeJson.csvfileUrl);
        }
      });
  };
}

export function editServiceDistribution(auth, editType, serviceCdEdit, distributionStatus) {
  return (dispatch) => {
    const param = {
      institutionId: auth.institutionId,
      authCd: auth.authCd,
      editType,
      distributionServiceInfo: {
        serviceCd: serviceCdEdit || '',
        distributionStatus: distributionStatus === null ? null : distributionStatus,
      },
    };
    const decamelDataToSearch = decamelizeKeys(param);
    return commonCallApi({
      path: 'contentsPermission/EditService',
      data: decamelDataToSearch,
    })
      .then((camelizeJson) => {
        const { distributionServiceInfo } = camelizeJson;
        const { serviceCd } = distributionServiceInfo;
        if (editType === distributionConstant.DISTRIBUTION_EDIT_TYPE.delete) {
          dispatch(actionCreators.receiveDistributionServiceDeleteResult(camelizeJson));
        }
      });
  };
}

function findIndexOfItemInArray(item, array, key) {
  return array.findIndex(o => o[key] === item[key]);
}

function findIndexOfItemInArrayRequiredOption(item, array, key, option) {
  return array.findIndex(o => o[key] === item[key] && o[option]);
}

export function getContentDistributionContentList(params) {
  return (dispatch) => {
    const deCamelSearchInfo = decamelizeKeys(params);
    return commonCallApi({
      path: 'content/GetList',
      data: deCamelSearchInfo,
    })
      .then((camelizeJson) => {
        dispatch(actionCreators.receiveContentDistributionContentList(camelizeJson));
      });
  };
}

export function getCourseList(params) {
  return (dispatch) => {
    const deCamelSearchInfo = decamelizeKeys(params);
    return commonCallApi({
      path: 'course/GetList',
      data: deCamelSearchInfo,
    })
      .then((camelizeJson) => {
        dispatch(actionCreators.receiveContentDistributionCourseList(camelizeJson));
      });
  };
}

export function getListImportedFile(options) {
  return (dispatch) => {
    const PARAM_DEFAULT = {
      returnMaxNum: RETURN_MAX_NUM,
    };
    sendGetDistributionListFileRequest(PARAM_DEFAULT, options).then((resdata) => {
      dispatch(actionCreators.receiveFileList(resdata));
    });
  };
}


export function importDistributionList(data, options) {
  return (dispatch) => {
    sendImportDistributionRequest(data, options).then((resdata) => {
      dispatch(actionCreators.receiveData(resdata, actionTypes.IMPORT_CONTENT_DISTRIBUTION_LIST));
    });
  };
}

export function contentDistributionUsageDetail(searchUsage, auth) {
  return (dispatch) => {
    const deCamelSearchUsage = decamelizeKeys(searchUsage);
    commonCallApi({
      path: 'contentsPermission/GetContentStatus',
      data: deCamelSearchUsage,
    })

      .then((camelizeJson) => {
        if (searchUsage.selectTargetData) {
          if (camelizeJson && camelizeJson.csvfileUrl) {
            const link = document.createElement('a');
            link.href = camelizeJson.csvfileUrl;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        } else {
          dispatch(actionCreators.downloadFormResponse(camelizeJson));
        }
      });
  };
}

export function courseDistributionUsageDetail(searchUsage) {
  return async (dispatch) => {
    const result = await getCourseStatus(searchUsage);
    if (searchUsage.selectTargetData) {
      if (result && result.csvfileUrl) {
        const link = document.createElement('a');
        link.href = result.csvfileUrl;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } else {
      dispatch(actionCreators.distributionCourseUsage(result));
    }
  };
}

export function getContentListToEdit(serviceCd, selectTargetData) {
  return (dispatch) => {
    const param = {
      selectTargetData,
      serviceCd,
      searchInfo: {},
    };
    const decamelDataToSearch = decamelizeKeys(param);
    return commonCallApi({
      path: 'contentsPermission/GetContentsList',
      data: decamelDataToSearch,
    })
      .then((camelizeJson) => {
        if (camelizeJson) {
          camelizeJson.serviceCd = serviceCd;
          return dispatch(actionCreators.receiveContentListToEdit(camelizeJson));
        }
        return {};
      });
  };
}

export function getCourseDistributionList(serviceCd, selectTargetData) {
  return (dispatch) => {
    const param = {
      selectTargetData,
      serviceCd,
      searchInfo: {},
    };
    const decamelDataToSearch = decamelizeKeys(param);
    return commonCallApi({
      path: 'contentsPermission/GetCourseList',
      data: decamelDataToSearch,
    })
      .then((camelizeJson) => {
        if (camelizeJson) {
          camelizeJson.serviceCd = serviceCd;
          return dispatch(actionCreators.receiveGetCourseDistributionList(camelizeJson));
        }
        return {};
      });
  };
}

export function resetDistributionOfferListDetail() {
  return (dispatch) => {
    dispatch(actionCreators.resetDistributionOfferListDetail());
  };
}

export function resetData() {
  return (dispatch) => {
    dispatch(actionCreators.resetDataDistributionOfferListEdit());
  };
}

export function removeAllDistributionCourseOrContentFromList(isContent) {
  return {
    type: actionTypes.REMOVE_ALL_DISTRIBUTION_COURSE_OR_CONTENT_FROM_LIST,
    isContent,
  };
}

// Step 11.0.0 START
export function sendSyncCourses() {
  return (dispatch) => doContentPermissionSyncCourses();
}

export function sendSyncContents() {
  return (dispatch) => doContentPermissionSendSyncContents();
}
// Step 11.0.0 END
